module.exports = __webpack_public_path__ + "static/media/8500.144ea151.jpg";